import { STEPS } from 'constants/Steps';

import generateReducer from '../steps';

/**
 * Generated form step reducet
 */
const stepsReducer = generateReducer(STEPS);
export { stepsReducer as steps };

export { default as error } from '../error';
export { default as pending } from '../pending';

export { default as habitations } from './habitations';
export { default as address } from './address';
export { default as auth } from './auth';
